
import type { PropType } from 'vue'
import type { PaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        paymentRequest: {
            type: Object as PropType<PaymentRequest>,
            required: true
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = () => {
            emit('click', props.paymentRequest)
        }

        return { onClick }
    }
})
